function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.472656 7.902344 C 6.59375 8.027344 6.59375 8.222656 6.472656 8.347656 C 6.347656 8.46875 6.152344 8.46875 6.027344 8.347656 L 2.902344 5.222656 C 2.84375 5.164062 2.8125 5.082031 2.8125 5 C 2.8125 4.917969 2.84375 4.835938 2.902344 4.777344 L 6.027344 1.652344 C 6.152344 1.53125 6.347656 1.53125 6.472656 1.652344 C 6.59375 1.777344 6.59375 1.972656 6.472656 2.097656 L 3.566406 5 Z M 6.472656 7.902344 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeftWhite);
export default __webpack_public_path__ + "static/media/caret_left_white.a234154598b55e3ec78714993f1e4453.svg";
export { ForwardRef as ReactComponent };